export default "__VITE_ASSET__0bc9219d__"